import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  getBroadcastGroupData,
  putBroadcastGroupData,
} from "@services/API/Requests/BroadcastGroupRequests";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TranslateErrorMessage } from "@services/ErrorHandling";
import { error_message } from "@constants/Errors";
import { YOBELY_PATHS } from "@constants/NavigationPaths";
import { BROADCASTGROUP } from "@types/broadcastGroup";
import {} from "../../common/YobelyGroupInfoCard";

export const UseEditYobelyGroupPage = () => {
  const { groupId } = useParams<{ groupId: string }>();
  const navigate = useNavigate();

  const [broadcastGroup, setBroadcastGroup] = useState<BROADCASTGROUP | null>(
    null,
  );
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");

  const [warningModalOpen, setWarningModalOpen] = useState(false);

  const errorToast = (response) => toast.error(`${response}`);
  const successToast = (response) => toast.success(`${response}`);

  const updateErrorToast = (errorMsg: string) => toast.error(`${errorMsg}`);

  const [errors, setErrors] = useState({
    name: false,
    name_kana: false,
  });

  useEffect(() => {
    const fetchBroadcastGroupData = async () => {
      try {
        setLoading(false);
        await getBroadcastGroupData(
          setBroadcastGroup,
          setLoading,
          setError,
          groupId,
        );
      } catch (err) {
        setError(error_message.broadcast_group.not_found);
        updateErrorToast(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBroadcastGroupData();
  }, [groupId]);

  const verifyFields = () => {
    return !Object.values(errors).some((error) => error === true);
  };

  const updateError = (field, value) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: value,
    }));
  };

  const handleInputChange = (key: string, value: string) => {
    setBroadcastGroup((prevState) =>
      prevState ? { ...prevState, [key]: value } : prevState,
    );
  };

  const handleSave = async (event) => {
    event.preventDefault();

    const fields: boolean = verifyFields();

    if (!fields) {
      errorToast(error_message.generic.bad_field);
      return;
    }

    if (broadcastGroup) {
      let response;
      setLoading(true);
      await putBroadcastGroupData(broadcastGroup, setLoading, setError)
        .then((response) => {
          if (response.status == 200) {
            successToast(response.message);
          } else {
            const errorMessage = TranslateErrorMessage(response.message);
            console.error(errorMessage);
            setError(TranslateErrorMessage(response.message));
            errorToast(errorMessage);
          }
        })
        .catch((error) => {
          const errorMessage = TranslateErrorMessage(response.message);
          console.error(errorMessage);
          setError(TranslateErrorMessage(response.message));
          errorToast(errorMessage);
        });
    }
    setLoading(false);
  };

  const handleOpenWarningModal = () => {
    setWarningModalOpen(true);
  };

  const handleCloseWarningModal = () => {
    setWarningModalOpen(false);
  };

  const onCancel = () => {
    navigate(YOBELY_PATHS.main);
  };

  return {
    loading,
    error,
    errors,
    broadcastGroup,
    groupId,
    warningModalOpen,
    onCancel,
    handleSave,
    handleInputChange,
    updateError,
    handleOpenWarningModal,
    handleCloseWarningModal,
  };
};
